/*
 * @Author: tager
 * @Date: 2022-06-09 16:30:36
 * @LastEditors: tager
 * @LastEditTime: 2022-06-27 10:34:42
 * @Description: 路由文件
 */
import { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Redirect from './components/redirect'
import { Splash } from './components/splash'
import { basename } from './helper/paths'

// 提示页
// const Tippage = lazy(
//   () => import(/* webpackChunkName: "Tippage" */ './pages/tippage')
// )
// 首页
const Homepage = lazy(
  () => import(/* webpackChunkName: "Homepage" */ './pages/homepage')
)
// 开始学习页面
const Exclusive = lazy(
  () => import(/* webpackChunkName: "Exclusive" */ './pages/exclusive')
)
// 退出页
const ExitPage = lazy(
  () => import(/* webpackChunkName: "ExitPage" */ './pages/exit')
)
// 课程页
const LecturePage = lazy(
  () => import(/* webpackChunkName: "LecturePage" */ './pages/lecture')
)
// 专栏页
const ChannelPage = lazy(
  () => import(/* webpackChunkName: "ChannelPage" */ './pages/channel')
)
// 个人中心页
const AccountPage = lazy(
  () => import(/* webpackChunkName: "AccountPage" */ './pages/account')
)
// 通用页面
const CommonPage = lazy(
  () => import(/* webpackChunkName: "CommonPage" */ './pages/common')
)
// 投放激活页面
const OcpmOauthPage = lazy(
  () => import(/* webpackChunkName: "CommonPage" */ './pages/oauth')
)
// 表单页面
const FormPage = lazy(
  () => import(/* webpackChunkName: "CommonPage" */ './pages/form')
)

export function Routers() {
  return (
    <Router basename={basename || '/'}>
      <Suspense fallback={<Splash />}>
        <Routes>
          <Route path="/" element={<CommonPage></CommonPage>} />
          <Route path="/indexpage" element={<Homepage></Homepage>} />
          <Route path="/homepage" element={<Homepage></Homepage>} />
          <Route path="/account3/exclusive" element={<Exclusive></Exclusive>} />
          <Route path="/lecture2/:id" element={<LecturePage></LecturePage>} />
          <Route path="/liveplay/:id" element={<Redirect to="/lecture2/" />} />
          <Route path="/liveplay2/:id" element={<Redirect to="/lecture2/" />} />
          <Route
            path="/classroom3/:id"
            element={<Redirect to="/lecture2/" />}
          />
          <Route path="/channel2/:id" element={<ChannelPage></ChannelPage>} />
          <Route
            path="/account3/myaccount"
            element={<AccountPage></AccountPage>}
          />
          <Route path="/ocpm/oauth/:id" element={<OcpmOauthPage />} />
          {/* 表单路由跳转 */}
          <Route path="/activity2/newform/:id" element={<FormPage />} />
          <Route path="/activity2/examform/:id" element={<FormPage />} />
          <Route path="/activity2/exam_resultList/:id" element={<FormPage />} />
          <Route path="/activity2/un_finishList/:id" element={<FormPage />} />
          <Route
            path="/activity2/exam_comment/:id/:record_id"
            element={<FormPage />}
          />
          <Route path="/exit" element={<ExitPage></ExitPage>} />
          <Route path="*" element={<CommonPage></CommonPage>} />
        </Routes>
      </Suspense>
    </Router>
  )
}
